import React, { useState } from 'react';
import { H3, InfoPopup, Modal, GuidePopup, Icons } from '../../../../../components';
import PriceInput from './PriceInput';
import css from './TalentPlusServices.module.css';
import UnlockableContentModal from './UnlockableContentModal';
import { FormattedMessage } from 'react-intl';
import { DIRECT_MESSAGE } from '../../../../../util/constants';
import { TALENT_SERVICES_GUIDES } from '../../../../../util/enums';
import { useFormState } from 'react-final-form';

const UnlockableContent = ({ option, fields, onLiveSave, values }) => {
  const currentFields = fields.value || [];
  const [modalOpen, setModalOpen] = useState(false);
  const [modalType, setModalType] = useState(null);
  const [expanded, setExpanded] = useState(false); // State for toggle expansion
  const { invalid } = useFormState();
  const handleOpenModal = type => {
    setModalType(type);
    setModalOpen(true);
  };

  const handleModalSave = () => {
    onLiveSave(values);
    handleCloseModal();
  };

  const handleCloseModal = () => {
    setModalOpen(false);
    setModalType(null);
  };

  const toggleExpand = () => {
    setExpanded(prev => !prev);
  };

  return (
    <div className={css.talentPlusServices}>
      <div role="button" className={css.serviceTitleRow} onClick={toggleExpand}>
        <h2 className={css.serviceTitle}>
          {option.service} {<GuidePopup externalLink={TALENT_SERVICES_GUIDES.UNLOCKABLE_CONTENT} />}
        </h2>
        <span className={css.iconWrapper}>
          {expanded ? <Icons name="upAngle" /> : <Icons name="downAngle" />}
        </span>
      </div>

      {expanded && (
        <div className={css.formRow}>
          {(option.types || []).map((typeObj, typeIndex) => {
            const { label, tooltip, guide } = typeObj;

            if (label === DIRECT_MESSAGE) {
              const existingIndex = currentFields.findIndex(
                item => item.service === option.service && item.type === label
              );
              const isChecked = existingIndex !== -1;
              const initialService = isChecked ? currentFields[existingIndex] : null;
              return (
                <div key={typeIndex} className={css.formFld}>
                  <label className={css.talentOptions}>
                    <input
                      type="checkbox"
                      checked={isChecked}
                      onChange={e => {
                        const isSelected = e.target.checked;
                        if (isSelected) {
                          fields.push({
                            service: option.service,
                            type: label,
                            selected: true,
                            price: initialService?.price || '',
                          });
                        } else if (existingIndex !== -1) {
                          fields.remove(existingIndex);
                        }
                        // onLiveSave(); // Trigger live save on change
                      }}
                    />
                    <span className={css.typeLabel}>
                      {label}
                      {tooltip && <InfoPopup triggerOn="hover" info={tooltip} />}
                      {guide && <GuidePopup externalLink={guide} />}
                    </span>
                  </label>

                  {isChecked && (
                    <PriceInput
                      type={label}
                      fieldIndex={existingIndex}
                      fields={fields}
                      service={option.service}
                      initialPrice={initialService?.price}
                    />
                  )}
                </div>
              );
            } else {
              return (
                <div key={typeIndex} className={css.formFld}>
                  <div className={css.modalTrigger}>
                    <span className={css.typeLabel}>
                      {label}
                      {tooltip && <InfoPopup triggerOn="hover" info={tooltip} />}
                      {guide && <GuidePopup externalLink={guide} />}
                    </span>
                    <button
                      type="button"
                      className={css.openModalButton}
                      onClick={() => handleOpenModal(label)}
                    >
                      <FormattedMessage
                        values={{ type: label }}
                        id="UnlockableContent.add"
                        defaultMessage={`+ Add ${label}`}
                      />
                    </button>
                  </div>
                </div>
              );
            }
          })}
        </div>
      )}

      <UnlockableContentModal
        isOpen={modalOpen}
        type={modalType}
        onClose={handleCloseModal}
        onSave={handleModalSave}
        values={values}
        invalid={invalid}
      />
    </div>
  );
};

export default UnlockableContent;
